// extracted by mini-css-extract-plugin
export default {"error":"RadioQuestion_error__GlFhO"};